import React, { useState, useEffect, useRef } from 'react';
import axios from '../../axiosConfig';
import { Form, Button,Modal,Table  } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer,toast} from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import SelectComponent from '../../components/SelectComponent';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons



const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado



const EditCursos = () => {
     const [formData, setFormData] = useState({
       descripcion: '',
       cantidad_horas: '',
       area_id: '',
       unidad_id:'',
       nivel_id:'',
       modalidad_id:'',
       sesiones:'',
       grupo_id:'',
       externo:'',
       area2_id:'',
       area3_id:'',
       area4_id:'',
       area5_id:'',
       activo:'',
       duracion:'',
       categoria_prog_id:'',
       audiencia:'',
       prelacion_id:'',
       virtual_modo_id:'',
       
     });

  const [filterOptions, setFilterOptions] = useState({
    areaOptions: [],
    unidadOptions: [],
    nivelOptions: [],
    modalidadOptions: [],
    grupoOptions: [],
    categoriaOptions:[],
    virtualOptions:[],
});

  const { id } = useParams(); // Obtener el id del curso de la URL
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  
  const [curso,setCurso]=useState('');
  const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores

   const [currentPageCursos, setCurrentPageCursos] = useState(1);
       const [paginatedCursos, setPaginatedCursos] = useState([]); // Usuarios en la página actual
       const [showCursoModal, setShowCursoModal] = useState(false);
           const [cursos, setCursos] = useState(null);
  const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially


  useEffect(() => {
    setLoading(true);
    handleSeleccionar();
    Promise.all([getCurso()]).finally(() => {
        setLoading(false);
    });
}, []);



  const getCurso = async () => {
    try {
      let relationsArray = ['prelacion'];
      const relations = relationsArray.join(',');
      const token = localStorage.getItem('token');
                  

      const response = await axios.get(`/cursos/${id}?with=${relations}`,{headers: {
        Authorization: `Bearer ${token}`,
    }});
      const curso = response.data;
      setCurso(curso);
      setCursos(curso.prelacion);
      setFormData({
      descripcion: curso.descripcion || '',
      cantidad_horas: curso.cantidad_horas || '',
      area_id: curso.area_id || '',
      area2_id: curso.area2_id || '',
      area3_id: curso.area3_id || '',
      area4_id: curso.area4_id || '',
      area5_id: curso.area5_id || '',

      nivel_id: curso.nivel_id || '',
      unidad_id: curso.unidad_id || '',  
      modalidad_id: curso.modalidad_id || '',  
      tipo_programa_id: curso.tipo_programa_id || '',
      cantidad_sesiones:curso.sesiones || '',
      grupo_id:curso.grupo_id || '',
      prelacion_id:curso.prelacion_id || '',
      activo:curso.activo || false,
      externo:curso.externo || false,
      prelacion_id:curso.prelacion_id || '',
      duracion:curso.duracion || '',
      sesiones :curso.sesiones || '',
      audiencia:curso.audiencia || '',
      categoria_prog_id:curso.categoria_prog_id || '',
      virtual_modo_id:curso.virtual_modo_id || '',
    });

    } catch (error) {
      setError('Error fetching course');
      console.error('Error fetching course:', error);
    }
  };

  const [error, setError] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };


  
    const [filtrosCurso, setFiltrosCurso] = useState({
        area_id: '',
        modalidad_id: '',
        nivel_id: '',
        tipo_programa_id: '',
        unidad_id:'',
        cod:'',
        grupo_id:'',
        curso_descripcion:'',
        activo:true,
        externo:false
    });


    const handleFilterCursoChange = (e) => {
        const { name, value } = e.target;
        setFiltrosCurso(prev => ({ ...prev, [name]: value }));
      };
       const handleOpenCursoModal = () => {
        getAllCursos(currentPageCursos);  // Obtener los cursos de la página actual
        setShowCursoModal(true);   // Mostrar el modal de cursos
    };
    
      
      
      const handleCursosPageChange = async (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            await getAllCursos(newPage);
        }
      };

       const handleSeleccionarCurso = (cursoSeleccionado) => {
        console.log("Curso seleccionado: ", cursoSeleccionado);  // Verifica si se selecciona correctamente
        setCursos(cursoSeleccionado); // Guardar el curso seleccionado en el estado
        setFormData(prevData => ({
            ...prevData,
            prelacion_id: cursoSeleccionado.curso_id,  // Almacenar el ID del curso seleccionado
        }));
        console.log("id del curso es: ", cursoSeleccionado.curso_id)
        setShowCursoModal(false); // Cerrar el modal
    };


    const getAllCursos = async (page = 1) => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`/cursos-paginate`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { ...filtrosCurso, page }, // Incluye `page` en los parámetros
                });
        
                const { data, last_page, current_page } = response.data.cursos;
        
                // Actualizar el estado
                setPaginatedCursos(data); // Datos de la página actual
                setCurrentPageCursos(current_page); // Página actual
                setTotalPages(last_page); // Total de páginas
            } catch (error) {
                console.error('Error fetching users:', error);
                toast.error('Error fetching data');
                setPaginatedCursos([]); // Limpia los datos en caso de error
            }
        };
  // const curso=formData.curso.cod;

  const handleSubmit = async (e) => {
    e.preventDefault();
  
   
  
    try {
      const token = localStorage.getItem('token');
  
      if (!token) {
        toast.error('Error: Token no encontrado');
        return;
      }
  
      // 1. Actualizar los datos del curso
      const formDataWithStatus = {
        ...formData,
      };
  
      const cursoResponse = await axios.put(`/cursos/${id}`, formDataWithStatus, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
     
        // Si hay campos vacíos, solo actualizamos los datos del curso
        toast.success('Curso actualizado ');
      
  
      // Redirigir después de la actualización
      navigate('/cursos');
  
    } catch (error) {
      // Captura cualquier error que ocurra en la solicitud
      toast.error('Error al actualizar curso o petición');
      console.error('Error actualizando:', error);
    }
  };

  const handleSeleccionar = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Suponiendo que el endpoint unificado sea `/filtros-cursos`
      const response = await axios.get(`/filtros-cursos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Desestructuramos los datos que vienen en la respuesta
      const { area, unidad, nivel, modalidad,grupo,categoriaProg,virtualmodo } = response.data;

    // Retornamos las opciones en un solo objeto
    setFilterOptions( {
      areaOptions: area,
      unidadOptions: unidad,
      nivelOptions: nivel,
      modalidadOptions: modalidad,
      grupoOptions:grupo,
      categoriaOptions:categoriaProg,
      virtualOptions:virtualmodo,
    });
      setSelectVisible(true);  // Mostrar los selectores
  
    } catch (error) {
      console.error('Error fetching filter options:', error);
      
    }
  };
  
  // Al elegir el tipo de programa se SUGIERE la carga horaria habitual, pero
  // se puede cambiar. Antes `cantidad_horas` estaba en las dependencias de
  // este efecto: cualquier numero que se escribiera se revertia a 2 o 4 en el
  // acto, asi que un programa de tipo 1 no admitia otra cosa que 2 horas.
  const tipoProgramaPrevio = useRef(formData.tipo_programa_id);
  useEffect(() => {
    // Al montar no se toca: en edicion pisaria las horas ya guardadas.
    if (tipoProgramaPrevio.current === formData.tipo_programa_id) return;
    tipoProgramaPrevio.current = formData.tipo_programa_id;

    const horasSugeridas = { "1": 2, "2": 4 }[formData.tipo_programa_id];
    if (horasSugeridas) {
      setFormData((prevState) => ({
        ...prevState,
        cantidad_horas: horasSugeridas,
        sesiones: 1,
      }));
    }
  }, [formData.tipo_programa_id]);

  // En el tipo 3 las sesiones si se derivan de las horas, cada vez que cambian.
  useEffect(() => {
    if (formData.tipo_programa_id !== "3") return;
    setFormData((prevState) => ({
      ...prevState,
      sesiones: prevState.cantidad_horas
        ? Math.floor(prevState.cantidad_horas / 4)
        : "",
    }));
  }, [formData.tipo_programa_id, formData.cantidad_horas]);



  return (
    <div className="row" style={{ marginTop: '50px' }}>
    <div className="col-lg-6 mx-auto"> {/* Centrado del contenido */}
      <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
        <h2 className="mb-2">Actualizar Curso {curso.cod}</h2>
         <Form onSubmit={handleSubmit} className="custom-gutter">
        <Form.Group controlId="externo">
              <Form.Label>¿Programa Externo?</Form.Label>
              <Form.Control
                  as="select"
                  name="externo"
                  value={formData.externo} // Asume que formData tiene la clave curso_externo
                  onChange={handleChange}
              >
                  <option value="">Seleccione</option>
                  <option value="true">Si</option>
                  <option value="false">No</option>
              </Form.Control>
          </Form.Group>
      <Form.Group controlId="activo">
        <Form.Label>Status de Programa</Form.Label>
        <Form.Control
            as="select"
            name="activo"
            value={formData.activo} // Asume que formData tiene la clave curso_externo
            onChange={handleChange}
            required
        >
            <option value="">Seleccione</option>
            <option value="true">Activo</option>
            <option value="false">Inactivo</option>
        </Form.Control>
    </Form.Group>

      <Form.Group controlId="descripcion">
              <Form.Label>Nombre del Programa</Form.Label>
              <Form.Control
                type="text"
                name="descripcion"
                maxLength={255}
                value={formData.descripcion}
                onChange={handleChange}
                required
              />
            </Form.Group>
              <SelectComponent
              options={filterOptions.modalidadOptions}  // Usar el estado filterOptions

              nameField="descripcion"
              valueField="id"
              selectedValue={formData.modalidad_id}
              handleChange={handleChange}
              controlId="modalidad_id"
              label="Modalidad"
            />
             {(formData.modalidad_id === '3' || formData.modalidad_id === 3) ? (
                <SelectComponent
                  options={filterOptions.virtualOptions}  // Usar el estado filterOptions
                  nameField="descripcion"
                  valueField="id"
                  selectedValue={formData.virtual_modo_id}
                  handleChange={handleChange}
                  controlId="virtual_modo_id"
                  label="Modo Virtual"
                />
              ) : (
                <SelectComponent
                  options={filterOptions.unidadOptions}  // Usar el estado filterOptions
                  nameField="descripcion"
                  valueField="id"
                  selectedValue={formData.unidad_id}
                  handleChange={handleChange}
                  controlId="unidad_id"
                  label="Unidad"
                />
              )}

             {/* <SelectComponent
                        options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData.grupo}
                        handleChange={handleChange}
                        controlId="grupo"
                        label="grupo"
                        required
                    /> */}

          <Row className="g-2">
          <Col md={6}>
            <Form.Group controlId="cantidad_horas">
              <Form.Label>Cantidad de Horas</Form.Label>
              <Form.Control
                type="number"
                name="cantidad_horas"
                value={formData.cantidad_horas}
                onChange={handleChange}
                maxLength={4}
                // disabled={formData.unidad_id === "1" || formData.unidad_id === "2"} // Bloquear si tipo_programa_id es 1 o 2
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="sesiones">
              <Form.Label>Cantidad de Sesiones</Form.Label>
              <Form.Control
                type="number"
                name="sesiones"
                value={formData.sesiones}
                onChange={handleChange}
                maxLength={4}
                // disabled={formData.unidad_id !== "3"} // Bloquear si tipo_programa_id no es 3
              />
            </Form.Group>
          </Col>

          </Row>
           {/* <Form.Group controlId="duracion">
              <Form.Label>Duraciòn</Form.Label>
              <Form.Control
                type="text"
                name="duracion"
                value={formData.duracion}
                onChange={handleChange}
                maxLength={100}
                required
              />
            </Form.Group> */}
          <Row className="g-2">
         
          <SelectComponent
              
              options={filterOptions.areaOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.area_id}
              handleChange={handleChange}
              controlId="area_id"
              label="Área"
            />
            
            <Col md={6}>
             {/* <SelectComponent
              
              options={filterOptions.categoriaOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.categoria_prog_id}
              handleChange={handleChange}
              controlId="categoria_prog_id"
              label="Categoria"
            /> */}
            
            </Col>
          
          </Row>
          {(formData.unidad_id === '4' || formData.unidad_id === 4) && (

            <>
            <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area2_id}
                handleChange={handleChange}
                controlId="area2_id"
                label="Área 2"
              />
          

              <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area3_id}
                handleChange={handleChange}
                controlId="area3_id"
                label="Área 3"
              />
                <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area4_id}
                handleChange={handleChange}
                controlId="area4_id"
                label="Área 4"
              />
              <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area5_id}
                handleChange={handleChange}
                controlId="area5_id"
                label="Área 5"
              />
              </>

            )}

          
        
         
          <SelectComponent
              options={filterOptions.nivelOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.nivel_id}
              handleChange={handleChange}
              controlId="nivel_id"
              label="Nivel"
            />
         
       
        {/* <Form.Group controlId="audiencia">
              <Form.Label>Audiencia</Form.Label>
              <Form.Control
                type="text"
                name="audiencia"
                value={formData.audiencia}
                onChange={handleChange}
                maxLength={255}
                required
              />
            </Form.Group> */}
{/* 
            <Form.Group controlId="curso">
                <Form.Label>Prelacion</Form.Label>
                <div className="d-flex">
                    {cursos ? (
                        <>
                            <Form.Control 
                                type="text" 
                                value={cursos.descripcion} 
                                readOnly 
                            />
                            <Button variant="secondary" onClick={handleOpenCursoModal} className="ms-2">
                                Cambiar
                            </Button>
                        </>
                    ) : (
                        <Button variant="info" onClick={handleOpenCursoModal}>
                            Seleccionar Unidad Curricular
                        </Button>
                    )}
                </div>
                
            </Form.Group> */}
        
        {/* <Form.Group controlId="fecha_inicio">
              <Form.Label>Fecha de Inicio</Form.Label>
              <Form.Control
                type="date"
                name="fecha_inicio"
                value={formData.fecha_inicio}
                onChange={handleChange}
              />
            </Form.Group> */}


        <div className="d-flex justify-content-end mt-3">
          <Button variant="secondary" onClick={() => navigate('/cursos')} className="me-2">
            Volver
          </Button>
          <Button variant="success" type="submit">
            Guardar
          </Button>
        </div>
      </Form>

      <Modal show={showCursoModal} onHide={() => setShowCursoModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar U.C de Prelacion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row className="mb-3 mt-3">
                <Col>
                <div className="d-flex align-items-center">
                        <Form.Control 
                            name= "cod"
                            type="text" 
                            placeholder="Buscar por Código (COD)" 
                            value={filtrosCurso.cod} 
                            onChange={handleFilterCursoChange} 
                        />
                        <Button 
                            variant="info me-2" 
                            onClick={getAllCursos}
                            style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                        >
                            <FaSearch className="me-1" /> {/* Ícono de lupa */}
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row>
            <Form.Control 
                    name= "curso_descripcion"
                    type="text" 
                    placeholder="Buscar por Nombre" 
                    value={filtrosCurso.curso_descripcion} 
                    onChange={handleFilterCursoChange} 
                />
            </Row>
      
                    <Row>
                        <Col>
                            <Form.Select 
                            name='area_id'
                            value={filtrosCurso.area_id}
                            onChange={(e) => setFiltrosCurso({ ...filtrosCurso, area_id: e.target.value })}>
                                <option value="">Filtrar por Área</option>
                                {filterOptions.areaOptions.map(area => (
                                    <option key={area.id} value={area.id}>{area.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Select
                            name='unidad_id'
                            value={filtrosCurso.unidad_id}
                              onChange={(e) => setFiltrosCurso({ ...filtrosCurso, unidad_id: e.target.value })}>
                                <option value="">Filtrar por Unidad</option>
                                {filterOptions.unidadOptions.map(unidad => (
                                    <option key={unidad.id} value={unidad.id}>{unidad.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Select
                            name='modalidad_id'
                            value={filtrosCurso.modalidad_id}
                              onChange={(e) => setFiltrosCurso({ ...filtrosCurso, modalidad_id: e.target.value })}>
                                <option value="">Filtrar por Modalidad</option>
                                {filterOptions.modalidadOptions.map(mod => (
                                    <option key={mod.id} value={mod.id}>{mod.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Select 
                            name='nivel_id'
                            value={filtrosCurso.nivel_id}
                            onChange={(e) => setFiltrosCurso({ ...filtrosCurso, nivel_id: e.target.value })}>
                                <option value="">Filtrar por Nivel</option>
                                {filterOptions.nivelOptions.map(nivel => (
                                    <option key={nivel.id} value={nivel.id}>{nivel.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Select 
                            name='grupo_id'
                            value={filtrosCurso.grupo_id}
                            onChange={(e) => setFiltrosCurso({ ...filtrosCurso, grupo_id: e.target.value })}>
                                <option value="">Filtrar por Grupo</option>
                                {filterOptions.grupoOptions.map(grupo => (
                                    <option key={grupo.id} value={grupo.id}>{grupo.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        
                    </Row>
      
                    <Table striped bordered hover className='mt-3'>
                        <thead>
                            <tr>
                                <th>COD</th>
                                <th>Descripción</th>
                                <th>Horas</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedCursos.map((curso) => (
                                <tr key={curso.id}>
                                    <td>{curso.cod}</td>
                                    <td>{curso.curso_descripcion}</td>
                                    <td>{curso.cantidad_horas}</td>
                                    <td>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Button variant="info" onClick={() => handleSeleccionarCurso(curso)} className="me-2">
                                                <i className="bi bi-check2-square"></i>
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
      
                </Modal.Body>
                <Modal.Footer>
                    
                    <Button
                        variant="secondary"
                        onClick={() => handleCursosPageChange(currentPageCursos - 1)}
                        disabled={currentPageCursos === 1}
                    >
                        Anterior
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => handleCursosPageChange(currentPageCursos + 1)}
                        disabled={currentPageCursos === totalPages}
                    >
                        Siguiente
                    </Button>
                    
                    <Button variant="secondary" onClick={() => setShowCursoModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
 
      
    </div>
    </div>
    </div>
  );
};

export default EditCursos;
